module.exports = __webpack_public_path__ + "img/电话.8e2ecf19.png";